import { all, put, select, takeLatest } from 'redux-saga/effects';
import { apiRequestEffect } from 'src/store/apiRequests';
import ViewerApi from 'src/apis/viewer';
import utils from 'src/utils';
import constants from 'src/constants';
import uiDux from 'src/redux/ui';
import appDux from 'src/redux/app/';
import jobShareDux from './index';

const { EMAIL_STATES } = constants.jobShare;
const { getJobShareImage } = utils.jobShare;

const getJobId = (state) => state.designPro.app.jobDetails.id;
const getJobShareId = (state) => state.designPro.jobShare.jobShareData.id;

export function* createJobShareSaga() {
  const jobId = yield select(getJobId);
  const shareToken = yield select(appDux.selectors.getShareToken);
  const imageBlob = getJobShareImage();
  const apiAction = { type: jobShareDux.actionTypes.CREATE_JOB_SHARE };
  const opts = { jobId, imageBlob, shareToken };

  yield apiRequestEffect(apiAction, ViewerApi.createJobShare, opts);
}

export function* createJobShareBeginSaga() {
  yield put(jobShareDux.actions.updateIsJobShareLoading(true));
  yield put(uiDux.actions.updateJobShareModalOpen(true));
}

export function* createJobShareEndSaga(action) {
  const { data } = action.payload;

  yield put(jobShareDux.actions.receiveJobShareData(data.job_share));
  yield put(jobShareDux.actions.updateIsJobShareLoading(false));
}

export function* sendJobShareEmailSaga(action) {
  const { email, senderText } = action.payload;
  const jobShareId = yield select(getJobShareId);
  const apiAction = { type: jobShareDux.actionTypes.SEND_JOB_SHARE_EMAIL };

  yield apiRequestEffect(
    apiAction,
    ViewerApi.updateJobShare,
    jobShareId,
    email,
    senderText,
  );
}

export function* sendJobShareEmailBeginSaga() {
  yield put(
    jobShareDux.actions.updateJobShareEmailState(EMAIL_STATES.sending.id),
  );
}

export function* sendJobShareEmailEndSaga() {
  yield put(jobShareDux.actions.updateJobShareEmailState(EMAIL_STATES.sent.id));
}

export default function* sagas() {
  yield all([
    takeLatest(jobShareDux.actionTypes.CREATE_JOB_SHARE, createJobShareSaga),
    takeLatest(
      jobShareDux.actionTypes.CREATE_JOB_SHARE_BEGIN,
      createJobShareBeginSaga,
    ),
    takeLatest(
      jobShareDux.actionTypes.CREATE_JOB_SHARE_END,
      createJobShareEndSaga,
    ),
    takeLatest(
      jobShareDux.actionTypes.SEND_JOB_SHARE_EMAIL,
      sendJobShareEmailSaga,
    ),
    takeLatest(
      jobShareDux.actionTypes.SEND_JOB_SHARE_EMAIL_BEGIN,
      sendJobShareEmailBeginSaga,
    ),
    takeLatest(
      jobShareDux.actionTypes.SEND_JOB_SHARE_EMAIL_END,
      sendJobShareEmailEndSaga,
    ),
  ]);
}
